import React from 'react'
import { Helmet } from 'react-helmet-async'
import OpeningHero from '../Components/openings/OpeningHero'
import FeaturedOpenings from '../Components/openings/FeaturedOpenings'
import ExploreOpenRoles from '../Components/openings/ExploreOpenRoles'

function AllOpenings() {
    return (
        <div>

            <Helmet>
                <title>
                    Current Job Openings at Mobikode | Explore Career Opportunities
                </title>

                <meta
                    name="description"
                    content="Explore current job openings at Mobikode and find opportunities across software development, engineering, AI, cloud, product development, Enterprise AI & ServiceNow Consulting, and other technology roles."
                />

                <meta
                    name="keywords"
                    content="Mobikode Job Openings, Mobikode Careers, Current Job Openings, Technology Jobs, IT Job Openings, Software Developer Jobs, Software Engineer Jobs, AI Jobs, Cloud Engineer Jobs, Product Engineer Jobs, IT Careers, Engineering Jobs, Software Development Jobs, Tech Jobs, Job Opportunities at Mobikode, Open Positions"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/openings"
                />

                <meta
                    property="og:title"
                    content="Current Job Openings at Mobikode | Explore Career Opportunities"
                />

                <meta
                    property="og:description"
                    content="Discover open positions at Mobikode and join a technology team working across software engineering, AI, cloud, product development, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/openings"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/openings/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Current Job Openings at Mobikode | Explore Career Opportunities"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's latest job opportunities and open roles across software development, AI, cloud engineering, product engineering, and technology."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/openings/bg1.png"
                />
            </Helmet>

            <OpeningHero />
            <FeaturedOpenings />
            <ExploreOpenRoles />

        </div>
    )
}

export default AllOpenings